// import '@babel/polyfill';
/* eslint-disable */
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';

import {
  initialiseClientGlobalSagas,
  initialiseGlobalReducer,
  setApplicationBootStrapActions,
  setGlobalPageTransitionActions,
} from '@fil-global/eiswagen';

import App from './App';

import applicationBootStrapActions, { globalPageTransitionActions } from './global/actions';
import globalReducers from './global/reducers';
import globalSagas from './global/sagas';

initialiseGlobalReducer(globalReducers); // Reducer which has to be initalised at the bootstrap level;
initialiseClientGlobalSagas(globalSagas); // All sagas that will be attached to store at bootstrap level
setApplicationBootStrapActions(applicationBootStrapActions); // All actions which needs to be triggered only once at application bootstrap
setGlobalPageTransitionActions(globalPageTransitionActions); // All actions which needs to be triggered at every page transition automatically

// ReactDOM.render(<App />, document.getElementById('root'));

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);
